export const DEFAULT_CURRENCY = 'EUR'; // TODO Remove and use i18n hook instead
export const DEFAULT_LOCALE = 'fr-FR'; // TODO Remove and i18n hook instead
export const FREEDELIVERY_LIMIT = {
  fr: 59,
  de: 49,
};
